// src/constants/saleConstants.js

// ---------- SALES MANAGEMENT ----------
export const ADD_SALE_REQUEST = "ADD_SALE_REQUEST";
export const ADD_SALE_SUCCESS = "ADD_SALE_SUCCESS";
export const ADD_SALE_FAIL = "ADD_SALE_FAIL";
export const ADD_SALE_RESET = "ADD_SALE_RESET";

export const UPDATE_SALE_REQUEST = "UPDATE_SALE_REQUEST";
export const UPDATE_SALE_SUCCESS = "UPDATE_SALE_SUCCESS";
export const UPDATE_SALE_FAIL = "UPDATE_SALE_FAIL";

export const DELETE_SALE_REQUEST = "DELETE_SALE_REQUEST";
export const DELETE_SALE_SUCCESS = "DELETE_SALE_SUCCESS";
export const DELETE_SALE_FAIL = "DELETE_SALE_FAIL";

export const GET_SALES_REQUEST = "GET_SALES_REQUEST";
export const GET_SALES_SUCCESS = "GET_SALES_SUCCESS";
export const GET_SALES_FAIL = "GET_SALES_FAIL";

export const GET_SALE_DETAIL_REQUEST = "GET_SALE_DETAIL_REQUEST";
export const GET_SALE_DETAIL_SUCCESS = "GET_SALE_DETAIL_SUCCESS";
export const GET_SALE_DETAIL_FAIL = "GET_SALE_DETAIL_FAIL";

export const IMPORT_SALES_CSV_REQUEST = "IMPORT_SALES_CSV_REQUEST";
export const IMPORT_SALES_CSV_SUCCESS = "IMPORT_SALES_CSV_SUCCESS";
export const IMPORT_SALES_CSV_FAIL = "IMPORT_SALES_CSV_FAIL";

export const GET_CUSTOMER_ORDERS_REQUEST = "GET_CUSTOMER_ORDERS_REQUEST";
export const GET_CUSTOMER_ORDERS_SUCCESS = "GET_CUSTOMER_ORDERS_SUCCESS";
export const GET_CUSTOMER_ORDERS_FAIL = "GET_CUSTOMER_ORDERS_FAIL";

// ---------- INVOICES & BILLING ----------
export const GENERATE_INVOICE_REQUEST = "GENERATE_INVOICE_REQUEST";
export const GENERATE_INVOICE_SUCCESS = "GENERATE_INVOICE_SUCCESS";
export const GENERATE_INVOICE_FAIL = "GENERATE_INVOICE_FAIL";

export const GET_INVOICE_HISTORY_REQUEST = "GET_INVOICE_HISTORY_REQUEST";
export const GET_INVOICE_HISTORY_SUCCESS = "GET_INVOICE_HISTORY_SUCCESS";
export const GET_INVOICE_HISTORY_FAIL = "GET_INVOICE_HISTORY_FAIL";

export const GET_PENDING_PAYMENTS_REQUEST = "GET_PENDING_PAYMENTS_REQUEST";
export const GET_PENDING_PAYMENTS_SUCCESS = "GET_PENDING_PAYMENTS_SUCCESS";
export const GET_PENDING_PAYMENTS_FAIL = "GET_PENDING_PAYMENTS_FAIL";

export const GET_PAYMENT_RECEIPTS_REQUEST = "GET_PAYMENT_RECEIPTS_REQUEST";
export const GET_PAYMENT_RECEIPTS_SUCCESS = "GET_PAYMENT_RECEIPTS_SUCCESS";
export const GET_PAYMENT_RECEIPTS_FAIL = "GET_PAYMENT_RECEIPTS_FAIL";

export const GET_RECURRING_INVOICES_REQUEST = "GET_RECURRING_INVOICES_REQUEST";
export const GET_RECURRING_INVOICES_SUCCESS = "GET_RECURRING_INVOICES_SUCCESS";
export const GET_RECURRING_INVOICES_FAIL = "GET_RECURRING_INVOICES_FAIL";

// ---------- CUSTOMER MANAGEMENT ----------
export const GET_CUSTOMER_LIST_REQUEST = "GET_CUSTOMER_LIST_REQUEST";
export const GET_CUSTOMER_LIST_SUCCESS = "GET_CUSTOMER_LIST_SUCCESS";
export const GET_CUSTOMER_LIST_FAIL = "GET_CUSTOMER_LIST_FAIL";

export const GET_CUSTOMER_PROFILES_REQUEST = "GET_CUSTOMER_PROFILES_REQUEST";
export const GET_CUSTOMER_PROFILES_SUCCESS = "GET_CUSTOMER_PROFILES_SUCCESS";
export const GET_CUSTOMER_PROFILES_FAIL = "GET_CUSTOMER_PROFILES_FAIL";

// ---------- SALES ANALYTICS & REPORTS ----------
export const GET_SALES_DASHBOARD_REQUEST = "GET_SALES_DASHBOARD_REQUEST";
export const GET_SALES_DASHBOARD_SUCCESS = "GET_SALES_DASHBOARD_SUCCESS";
export const GET_SALES_DASHBOARD_FAIL = "GET_SALES_DASHBOARD_FAIL";

export const GET_SALES_BY_PRODUCT_REQUEST = "GET_SALES_BY_PRODUCT_REQUEST";
export const GET_SALES_BY_PRODUCT_SUCCESS = "GET_SALES_BY_PRODUCT_SUCCESS";
export const GET_SALES_BY_PRODUCT_FAIL = "GET_SALES_BY_PRODUCT_FAIL";

export const GET_SALES_GROWTH_TRENDS_REQUEST = "GET_SALES_GROWTH_TRENDS_REQUEST";
export const GET_SALES_GROWTH_TRENDS_SUCCESS = "GET_SALES_GROWTH_TRENDS_SUCCESS";
export const GET_SALES_GROWTH_TRENDS_FAIL = "GET_SALES_GROWTH_TRENDS_FAIL";

// ---------- PAYMENT MANAGEMENT ----------
export const GET_PAYMENT_METHODS_REQUEST = "GET_PAYMENT_METHODS_REQUEST";
export const GET_PAYMENT_METHODS_SUCCESS = "GET_PAYMENT_METHODS_SUCCESS";
export const GET_PAYMENT_METHODS_FAIL = "GET_PAYMENT_METHODS_FAIL";

export const GET_PARTIAL_PAYMENTS_REQUEST = "GET_PARTIAL_PAYMENTS_REQUEST";
export const GET_PARTIAL_PAYMENTS_SUCCESS = "GET_PARTIAL_PAYMENTS_SUCCESS";
export const GET_PARTIAL_PAYMENTS_FAIL = "GET_PARTIAL_PAYMENTS_FAIL";

export const GET_REFUND_PROCESSING_REQUEST = "GET_REFUND_PROCESSING_REQUEST";
export const GET_REFUND_PROCESSING_SUCCESS = "GET_REFUND_PROCESSING_SUCCESS";
export const GET_REFUND_PROCESSING_FAIL = "GET_REFUND_PROCESSING_FAIL";

export const GET_PAYMENT_REMINDERS_REQUEST = "GET_PAYMENT_REMINDERS_REQUEST";
export const GET_PAYMENT_REMINDERS_SUCCESS = "GET_PAYMENT_REMINDERS_SUCCESS";
export const GET_PAYMENT_REMINDERS_FAIL = "GET_PAYMENT_REMINDERS_FAIL";

// ---------- RETURNS & REFUNDS ----------
export const GET_RETURN_REQUESTS_REQUEST = "GET_RETURN_REQUESTS_REQUEST";
export const GET_RETURN_REQUESTS_SUCCESS = "GET_RETURN_REQUESTS_SUCCESS";
export const GET_RETURN_REQUESTS_FAIL = "GET_RETURN_REQUESTS_FAIL";

export const GET_REFUND_STATUS_REQUEST = "GET_REFUND_STATUS_REQUEST";
export const GET_REFUND_STATUS_SUCCESS = "GET_REFUND_STATUS_SUCCESS";
export const GET_REFUND_STATUS_FAIL = "GET_REFUND_STATUS_FAIL";

export const GET_DAMAGED_GOODS_RETURNS_REQUEST = "GET_DAMAGED_GOODS_RETURNS_REQUEST";
export const GET_DAMAGED_GOODS_RETURNS_SUCCESS = "GET_DAMAGED_GOODS_RETURNS_SUCCESS";
export const GET_DAMAGED_GOODS_RETURNS_FAIL = "GET_DAMAGED_GOODS_RETURNS_FAIL";

export const GET_CUSTOMER_REFUND_APPROVALS_REQUEST = "GET_CUSTOMER_REFUND_APPROVALS_REQUEST";
export const GET_CUSTOMER_REFUND_APPROVALS_SUCCESS = "GET_CUSTOMER_REFUND_APPROVALS_SUCCESS";
export const GET_CUSTOMER_REFUND_APPROVALS_FAIL = "GET_CUSTOMER_REFUND_APPROVALS_FAIL";

export const GET_SUPPLIER_RETURN_MANAGEMENT_REQUEST = "GET_SUPPLIER_RETURN_MANAGEMENT_REQUEST";
export const GET_SUPPLIER_RETURN_MANAGEMENT_SUCCESS = "GET_SUPPLIER_RETURN_MANAGEMENT_SUCCESS";
export const GET_SUPPLIER_RETURN_MANAGEMENT_FAIL = "GET_SUPPLIER_RETURN_MANAGEMENT_FAIL";

export const GET_WARRANTY_BASED_RETURNS_REQUEST = "GET_WARRANTY_BASED_RETURNS_REQUEST";
export const GET_WARRANTY_BASED_RETURNS_SUCCESS = "GET_WARRANTY_BASED_RETURNS_SUCCESS";
export const GET_WARRANTY_BASED_RETURNS_FAIL = "GET_WARRANTY_BASED_RETURNS_FAIL";

// ---------- CLEAR ERRORS/MESSAGES ----------
export const CLEAR_SALE_ERRORS = "CLEAR_SALE_ERRORS";
export const CLEAR_SALE_MESSAGES = "CLEAR_SALE_MESSAGES";

// **New**: Add Return/Refund
export const ADD_RETURN_REFUND_REQUEST = "ADD_RETURN_REFUND_REQUEST";
export const ADD_RETURN_REFUND_SUCCESS = "ADD_RETURN_REFUND_SUCCESS";
export const ADD_RETURN_REFUND_FAIL = "ADD_RETURN_REFUND_FAIL";
export const ADD_RETURN_REFUND_RESET = "ADD_RETURN_REFUND_RESET";   



export const CREATE_SALE_WITH_CUSTOM_INVOICE_REQUEST = "CREATE_SALE_WITH_CUSTOM_INVOICE_REQUEST";
export const CREATE_SALE_WITH_CUSTOM_INVOICE_SUCCESS = "CREATE_SALE_WITH_CUSTOM_INVOICE_SUCCESS";
export const CREATE_SALE_WITH_CUSTOM_INVOICE_FAIL = "CREATE_SALE_WITH_CUSTOM_INVOICE_FAIL";
export const CREATE_SALE_WITH_CUSTOM_INVOICE_RESET = "CREATE_SALE_WITH_CUSTOM_INVOICE_RESET";
